<template>
    <div>
        <v-layout align-center class="mb-3">
            <v-text-field
                v-model="entity"
                :placeholder="$t('searchBy.entity')"
                hide-details
                class="mr-3"
            ></v-text-field>
            <v-text-field
                v-model="searchKey"
                :placeholder="$t('searchBy.keywordOrSynonym')"
                hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            <v-btn class="mx-0" @click="createItem" v-if="isEditable">{{$t('new')}}</v-btn>
        </v-layout>
        <SimpleDataTable
            :headers="headers"
            :items="filterItemList"
            :pagination="pagination"
        >
            <template v-slot:action="props">
                <v-btn icon @click="editItem(props.item)"><v-icon>mdi-pencil</v-icon></v-btn>
                <v-btn icon @click="deleteItem(props.item)"><v-icon>mdi-delete</v-icon></v-btn>
            </template>
            <template v-slot:synonym="{item}">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{$utils.limitStringLength(item.synonym.join('; '), 70)}}</span>
                    </template>
                    <div>
                        <div v-for="(item, i) in item.synonym" :key="i">{{item}}</div>
                    </div>
                </v-tooltip>
            </template>
        </SimpleDataTable>
    </div>
</template>

<script>
import SimpleDataTable from "@/modules/fptai/components/SimpleDataTable";
import { mapState } from "vuex";
import { ScenarioEventBus, ScenarioEventBusType } from "@/views/Scenario/scenario.eventbus";
import NLP_Service from "@/services/nlp.service";
import NLPItemList from "@/views/Scenario/nlp/NLPItemList";
import ScenarioService from "@/services/scenario.service";

export default {
    name: "KeywordList",
    components: { SimpleDataTable },
    extends: NLPItemList,
    data () {
        return {
            entity: ''
        }
    },
    computed: {
        ...mapState({
            itemList: state => state.scenario.keywordList
        }),
        filterItemList () {
            let search = this.$utils.nonAccentVietnamese(this.searchKey)
            let entity = this.entity
            return this.itemList.filter(item =>
                (
                    !search ||
                    this.$utils.nonAccentVietnamese(item.value).includes(search) ||
                    this.$utils.nonAccentVietnamese(item.synonym.join(',')).includes(search)
                ) &&
                item.entity_label.includes(entity)
            )
        },
        headers () {
            return this.$appService.correctHeaders([
                {
                    text: this.$t('entity'),
                    value: 'entity_label'
                },
                {
                    text: this.$t('keyword'),
                    value: 'value'
                },
                {
                    text: this.$t('synonym'),
                    value: 'synonym',
                    type: 'custom',
                    id: 'synonym'
                },
                {
                    text: this.$t('action'),
                    value: 'action',
                    type: 'custom',
                    id: 'action',
                    visible: this.isEditable
                }
            ])
        },
        isEditable: () => ScenarioService.isEditable()
    },
    methods: {
        filterItem ({ entity, search }) {
            this.searchKey = search ? search : ''
            this.entity = entity ? entity : ''
        },
        searchItem () {
            this.$store.dispatch(this.$actionTypes.scenario.GET_KEYWORD_LIST, this.$route.params.scenarioId)
        },
        createItem () {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_KEYWORD, {
                item: null,
                resolve: this.searchItem
            })
        },
        editItem (item) {
            ScenarioEventBus.$emit(ScenarioEventBusType.CREATE_KEYWORD, {
                item,
                resolve: this.searchItem
            })
        },
        deleteItem (item) {
            this.$appService.confirm(this.$t('confirmDelete', { item: this.$t('keyword') + ': ' + item.value })).then(
                () => {
                    let i18n = {
                        action: this.$t('delete'),
                        item: this.$t('keyword')
                    }
                    this.$appService.showLoading()
                    NLP_Service.KeywordService.delete(
                        this.$route.params.scenarioId,
                        item.entity_label,
                        item.code
                    ).then(
                        () => {
                            this.$appService.toastSuccess(this.$t('actionSuccessful', i18n))
                            this.searchItem()
                        },
                        this.$appService.handleRequestError(this.$t('actionFailed', i18n))
                    ).finally(this.$appService.hideLoading)
                }
            )
        }
    }
}
</script>

<style scoped>

</style>
